import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import InputImagenesTitulo from "../../components/imagenes_con_titulo/InputImagenesTitulo";
import useTopStore from "../../store/topStore";
import Loader from "../../components/Loader";
import SelectMultiForm from '../../components/SelectMultiForm';
const TopPage = () => {

  const { isLoading, iniciar, platillos, multiImagenesTemp, handleChangeImagen, handleSave, sucursales, sucursalSelecionada, handleSucursales,esMostrar } = useTopStore();
  
  useEffect(() => {
    iniciar();
  }, []);
  
  return (
    <>
      <MasterLayout>
        {
          isLoading ?
          <Loader /> :
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title"> TOP</h4>
                  <button className="btn btn-primary" onClick={handleSave}>Guardar</button>
                </div>
                <div className="card-body">
                  <SelectMultiForm
                    col="col-sm-12"
                    datos={sucursales} 
                    change={handleSucursales}
                    values={sucursalSelecionada}
                    placeholder="Seleccione una o varias sucursales"
                    name="sucursalesOrden"
                    isMulti={false}
                  />
                  {
                    esMostrar &&
                    <InputImagenesTitulo
                      multiImagenes={multiImagenesTemp.filter(imagenes=>imagenes.sucursal == sucursalSelecionada[0].value)}
                      handleChangeImagen={handleChangeImagen}
                      ratio={4/3}
                      maxImages={4}
                      name="IMAGENES_TOP"
                      categorias={platillos}
                      sucursal = {sucursalSelecionada[0].value ?? 0}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </MasterLayout>
    </>
  );
};

export default TopPage;